<template>
  <el-card class="box-card">
    <a href="http://kaitoritopone.jp">
      <img src="@/assets/logo_.jpg" style="height: 35px;">
    </a>
    <div class="userBox">
      <el-badge is-dot class="cateIcon">
        <img
          src="../assets/productList/catgory.png"
          alt=""
          @click="$router.push('/shoppingCart')"
        />
      </el-badge>
      <el-button
        size="mini"
        type="text"
        style="margin-bottom: 10px"
        @click="$router.push('/login')"
        v-if="!isLogin"
        >{{ $t("button.denglu") }}</el-button
      >
      <el-dropdown v-else class="infoBox" @command="handleCommand">
        <span class="el-dropdown-link">
          {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in infoList"
            :key="item.name"
            :command="item.path"
            >{{ item.name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-card>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      userName: sessionStorage.getItem("userInfo"),
      isLogin: sessionStorage.getItem("userInfo") ? true : false,
      infoList: [
        {
          name: this.$t("common.zhanghu"),
          path: "/userInfo",
        },
        {
          name: this.$t("common.zhuxiao"),
          path: "/",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handleCommand(path) {
      if (path === "/") {
        sessionStorage.removeItem("userInfo");
        sessionStorage.removeItem("userID");
        this.$message.success("ログアウト完了");
        this.isLogin = false;
      }
      this.$router.push(path);
    },
  },
};
</script>
<style scoped lang="less">
.box-card {
  position: fixed;
  width: 100%;
  height: 60px;
  left: 0;
  top: 0;
  z-index: 10;
}
.userBox {
  position: absolute;
  right: 50px;
  top: 30%;
}
.infoBox {
  cursor: pointer;
}
.cateIcon {
  margin-right: 50px;
  cursor: pointer;
  img {
    width: 22px;
  }
}
@media screen and (max-width: 768px) {
  .userBox {
    position: absolute;
    right: 10px;
    top: 25%;
  }
  .cateIcon {
    margin-right: 25px;
    img {
      width: 18px;
    }
  }
}
</style>